import { OfflineRequestsForm } from './OfflineRequests.entity';

export const OFFLINE_REQUEST_FORM_INITIAL: OfflineRequestsForm = {
  comment: '',
  driverId: null,
  methodOfReceptionId: null,
  printNumber: undefined,
  quantity: undefined,
  requestId: null,
  transportId: null,
};
